import { Radio } from "antd";
import { ModalComponentProps } from "../../types";
import CustomModal from "../ui/CustomModal";

export default function FeaturesView({
  handleClose,
  data,
  type,
  ...rest
}: ModalComponentProps) {
  return (
    <CustomModal
      title="Features"
      {...rest}
      handleClose={handleClose}
      width={300}
      footer={null}
    >
      <div className="">
        <Radio.Group
          className="custom-radio custom_radio_for_features !h-auto w-full space-y-2.5"
          size="large"
        >
          <div className="w-full">
            <Radio className="text-header text-sm font-medium mr-3.5 ">
              Features title will go here
            </Radio>
          </div>
          <div className="w-full">
            <Radio className="text-header text-sm font-medium mr-3.5 ">
              Features title will go here
            </Radio>
          </div>
          <div className="w-full">
            <Radio className="text-header text-sm font-medium mr-3.5 ">
              Features title will go here
            </Radio>
          </div>
          <div className="w-full">
            <Radio className="text-header text-sm font-medium mr-3.5 ">
              Features title will go here
            </Radio>
          </div>
          <div className="w-full">
            <Radio className="text-header text-sm font-medium mr-3.5 ">
              Features title will go here
            </Radio>
          </div>
        </Radio.Group>
      </div>
    </CustomModal>
  );
}
